import React from 'react';

// Number of placeholders to add at the beginning. Adjust if needed.
const NUM_PLACEHOLDERS_START = 15;
// Styling for placeholders to occupy similar space as a minimal item.
const PLACEHOLDER_STYLE = {
  minWidth: '20px', // Give placeholders a bit of width
  marginRight: '10px',
  height: '30px', // Match typical item height roughly
  opacity: 0.5,
  display: 'flex',
  flexShrink: 0, // Prevent placeholders from shrinking
  // background: 'rgba(128,128,128,0.1)', // For debugging placeholder visibility
};


const PriceTimeline = ({ electricityPrices = [], currentHour, timelineRef, currentItemRef }) => {
  const iconBaseSize = 18;
  const currentHourIconSize = 22;
  const itemBasePadding = '7px';
  const currentHourItemPadding = '9px';

  const startPlaceholders = Array.from({ length: NUM_PLACEHOLDERS_START }, (_, i) => ({
    id: `ph-start-price-${i}`,
    isPlaceholder: true,
  }));

  // Combine placeholders with actual data. Mark actual data items.
  const combinedItems = [
    ...startPlaceholders,
    ...electricityPrices.map((item, index) => ({
      ...item,
      originalIndex: index, // Keep track of original index for key and currentHour check
      isPlaceholder: false,
    })),
  ];

  return (
    <div style={{ marginTop: '15px' }} className='slide-in-left-transition'>
      <div
        ref={timelineRef}
        style={{
          display: 'flex',
          overflowX: 'hidden',
          height: '70px',
          whiteSpace: 'nowrap',
          border: '3px solid #009DDC',
          backgroundColor: 'rgba(0, 35, 102, 0.5)',
          backdropFilter: 'blur(15px)',
          padding: '5px',
          borderRadius: '13px',
        }}
      >
        {combinedItems.map((item, combinedIndex) => {
          if (item.isPlaceholder) {
            return <div key={item.id} style={PLACEHOLDER_STYLE}> </div>;
          }

          // This is an actual data item
          const isCurrent = item.originalIndex === currentHour;

          return (
            <div
              key={`price-item-${item.originalIndex}`}
              ref={isCurrent ? currentItemRef : null}
              style={{
                maxWidth: '10px',
                minWidth: '5px', // Actual items can still be small
                marginRight: '10px',
                textAlign: 'center',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                padding: isCurrent ? currentHourItemPadding : itemBasePadding,
                background: isCurrent ? '#e4299c' : 'transparent',
                borderRadius: '4px',
                // Removed transform: scale()
                transition: 'background-color 0.2s ease-in-out, padding 0.2s ease-in-out',
                flexShrink: 0, // Prevent actual items from shrinking too much
              }}
            >
              <div style={{ fontSize: '18px', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                {Array.from({ length: item.priceLevel }, (_, idx) => (
                  <img
                    key={idx}
                    src="/cost.svg"
                    alt="Price level"
                    style={{
                      width: `${isCurrent ? currentHourIconSize : iconBaseSize}px`,
                      height: `${isCurrent ? currentHourIconSize : iconBaseSize}px`,
                      transition: 'width 0.2s ease-in-out, height 0.2s ease-in-out',
                    }}
                  />
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PriceTimeline;